import preloadEnums from '../enums/preload';

/**
 * Generates a jwplayer playlist from sources and poster
 *
 * @method generatePlaylist
 * @public
 *
 * @param {Object} param - argument object
 * @param {Array} param.sources - Sources to set
 * @param {String} param.poster - Poster to set
 *
 * @returns {Array} a jwplayer playlist
 *
 */
export default function generatePlaylist({ sources, poster }) {
  return [{
    image   : poster,
    sources : sources.map((source) => {
      const returnObject = {
        file  : source.src,
        label : source.label
      };

      if (source.selected) {
        returnObject.default = true;
      }
      if (source.preload !== undefined) {
        if (Object.values(preloadEnums).includes(source.preload)) {
          returnObject.preload = source.preload;
        } else {
          throw new Error(`${source.preload} is not a valid preload value`);
        }
      }

      return returnObject;
    })
  }];
}



// WEBPACK FOOTER //
// ./src/utils/generatePlaylist.js